<template lang="pug">
.message-history-family-list
  span(v-if="value.length <= 0") 情報がありません。
  template(v-else v-for="family in _value")
    .family.d-flex.flex-column
      // resident
      .mb-0
        span.key-name 利用者名（部屋名）
      .mb-0.resident-name {{ family.residentName }}（{{ family.residentRoomName }}）
      // family
      .mb-0
        span.key-name 家族名（続柄）
      .mb-2.family-name {{ getFamilyInfo(family) }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { SendMessageReadFamilyModel } from "@/commons/services/SendMessageReadFamilies";

/**
 * ### メッセージ履歴詳細家族一覧コンポーネント
 */
@Component({})
export default class MessageHistoryFamilyList extends Vue {
  @Prop({ required: true })
  value!: Array<SendMessageReadFamilyModel>;

  get _value(): Array<SendMessageReadFamilyModel> {
    return this.value;
  }

  public getFamilyInfo(family: SendMessageReadFamilyModel): string {
    const name: string = family.familyName;
    const relation: string = family.familyRelation;
    if (relation) {
      return `${name}（${relation}）`;
    } else {
      return `${name}（未設定）`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_colors.scss";

.message-history-family-list {
  .key-name {
    font-weight: bold;
    font-size: 1rem;
    margin-right: 0.5rem;
  }
  .family {
    border-bottom: 1px solid $border-default;

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
